import { useQuery } from '@tanstack/react-query';

import type { ControlMessageCategory } from '@/types/category';

import httpClient from '@/lib/axios-instance';
import { API_ROUTES } from '@/lib/routes/api-routes';

export const PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY = ['predefinedMessageCategories'] as const;

async function fetchCategories() {
  const { data } = await httpClient.get<ControlMessageCategory[]>(
    API_ROUTES.predefinedMessageCategories.list
  );

  return data;
}

export function useCategoriesQuery(enabled = true) {
  return useQuery({
    queryKey: PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY,
    queryFn: fetchCategories,
    staleTime: Number.POSITIVE_INFINITY,
    enabled,
  });
}
